import Link from 'next/link';
import {UrlImage} from '@/components/menu/types';

type SocialLinkGradientProps = {
    children: React.ReactNode;
    item: {image: string} & Partial<UrlImage>;
    url: string;
    style?: 'light' | 'dark';
    size?: 'medium' | 'large';
  }

  const SocialLinkGradient = (props:SocialLinkGradientProps) => {
    const {item, url, style = 'dark', size='medium'} = props;


    const sizeParams = {
      link: {
        medium: 'h-[44px] w-[44px]',
        large: 'h-[50px] w-[50px]'
      },
      image: {
        medium: 'h-[42px] w-[42px]',
        large: 'h-[48px] w-[48px]'
      }
    }

    const classes = {
      dark: {
        link: `flex ${sizeParams.link[size]} items-center justify-center rounded-full border border-gray-800 hover:border-none hover:border-socials`,
        imageContainer: `flex ${sizeParams.image[size]} social-image-container social-image-container-dark hover:bg-gradient-blue-red-diagonal-socials-dark`
      },
      light: {
        link: `flex ${sizeParams.link[size]} items-center justify-center rounded-full border border-[#DEE2EC] hover:border-none hover:border-socials`,
        imageContainer: `flex ${sizeParams.image[size]} social-image-container social-image-container-light hover:bg-gradient-blue-red-diagonal-socials-light`
      }
    }

    return (style && 
      <Link
        href={url}
        target={item?.external ? '_blank' : '_self'}
        className={classes[style].link}
      >
        <div className={classes[style].imageContainer}>
          {item.image && <> {props.children} </> }
        </div>
      </Link>
    )
  }

  export default SocialLinkGradient;